import { clearCanvas, drawGrid, normalizeRange, setupCanvas } from './canvas-utils';

export function renderAreaChart(canvas: HTMLCanvasElement, values: number[], stroke: string = '#15b57a', fill: string = 'rgba(21,181,122,0.18)'): void {
    const setup = setupCanvas(canvas);
    if (!setup) return;
    const { ctx, width, height } = setup;

    clearCanvas(ctx, width, height);
    drawGrid(ctx, width, height, 4, 4, 'rgba(255,255,255,0.08)');

    if (values.length < 2) return;
    const { min, max } = normalizeRange(values);

    ctx.beginPath();
    values.forEach((v, i) => {
        const x = (i / (values.length - 1)) * width;
        const y = height - ((v - min) / (max - min)) * height;
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
    });
    ctx.lineTo(width, height);
    ctx.lineTo(0, height);
    ctx.closePath();

    ctx.fillStyle = fill;
    ctx.fill();

    ctx.beginPath();
    values.forEach((v, i) => {
        const x = (i / (values.length - 1)) * width;
        const y = height - ((v - min) / (max - min)) * height;
        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
    });
    ctx.strokeStyle = stroke;
    ctx.lineWidth = 2;
    ctx.stroke();
}
